// extracted by mini-css-extract-plugin
module.exports = {"quotes-container":"doubleQuotes_quotes-container__3QQq6"};